import {useEffect, useState} from "react"
import style from './EditMemberDetails.module.scss'
import TrayToggle from "../../ui-components/TrayToggle/TrayToggle"
import FirstNameInput from "../Inputs/FirstNameInput"
import SurNameInput from "../Inputs/SurNameInput"
import EmailInput from "../Inputs/EmailInput"
import PhoneInput from "../Inputs/PhoneInput"
import usePost from "../../../hooks/usePost";
import SelectInput from "../Inputs/SelectInput";
import {genderList} from "../../../data/genderSelect";

function EditMemberDetails({member, onSuccess, onCancel}) {

    const {postData, sending, showMessage, showSuccessMessage, returnMsg, returnPostData} = usePost()

    const [firstName, setFirstName] = useState(member.first_name)
    const [surName, setSurName] = useState(member.surname)
    const [gender, setGender] = useState(member.gender)
    const [email, setEmail] = useState(member.email)
    const [phone, setPhone] = useState(member.phone)
    const [forceValidation, setForceValidation] = useState(false)

    useEffect(() => {
        if(returnPostData){
            onSuccess(JSON.parse(returnPostData.userData))
        }
    }, [returnPostData, onSuccess])

    function formSubmitHandler(e) {
        e.preventDefault()
        setForceValidation(true)

        if(firstName && surName && email && phone) {
            const data = {
                memberId: member.id,
                firstName: firstName,
                surName: surName,
                gender: gender,
                oldEmail: member.email,
                email: email,
                phone: phone
            }
            postData(data, '/api/members/update/', 500)
        }
    }

    function firstNameHandler(status){
        setFirstName(status)
    }

    function surNameHandler(status){
        setSurName(status)
    }

    function genderHandler(status){
        setGender(status)
    }

    function emailHandler(status){
        setEmail(status)
    }

    function phoneHandler(status){
        setPhone(status)
    }

    return (
        <>
            <form onSubmit={formSubmitHandler} className={"form"} action="">

                <div className={"field field--half"}>
                    <FirstNameInput
                        defaultValue={firstName}
                        value={(status) => firstNameHandler(status)}
                        sending={sending}
                        forceValidation={forceValidation}
                        label={"First Name"}
                    />
                </div>

                <div className={"field field--half"}>
                    <SurNameInput
                        defaultValue={surName}
                        value={(status) => surNameHandler(status)}
                        sending={sending}
                        forceValidation={forceValidation}
                        label={"Surname"}
                    />
                </div>

                <div className={"field"}>
                    <SelectInput
                        label={"I identify my gender as"}
                        options={genderList}
                        selected={gender}
                        value={(status) => genderHandler(status)}
                        sending={sending}
                        forceValidation={forceValidation}
                    />
                </div>

                <div className={"field"}>
                    <EmailInput
                        defaultValue={email}
                        value={(status) => emailHandler(status)}
                        sending={sending}
                        forceValidation={forceValidation}
                        label={"Email address"}
                    />
                </div>

                <div className={"field"}>
                    <PhoneInput
                        defaultValue={phone}
                        value={(status) => phoneHandler(status)}
                        sending={sending}
                        forceValidation={forceValidation}
                        label={"Phone"}
                    />
                </div>

                <TrayToggle open={showMessage}>
                    <div className={["ReturnMsg", 'ReturnMsgError'].join(" ")}>{returnMsg}</div>
                </TrayToggle>
                <TrayToggle open={showSuccessMessage}>
                    <div className={'ReturnMsg'}>{returnMsg}</div>
                </TrayToggle>

                <button className={"submit"} type="submit" disabled={sending}>{!sending ? "Update" : "Updating..."}</button>
                <button className={style.cancel} type="button" onClick={onCancel} disabled={sending}>Cancel</button>
            </form>
        </>
    )
}

export default EditMemberDetails
